import { render, staticRenderFns } from "./NavigatorBar.vue?vue&type=template&id=4528f228&scoped=true"
import script from "./NavigatorBar.vue?vue&type=script&lang=js"
export * from "./NavigatorBar.vue?vue&type=script&lang=js"
import style0 from "./NavigatorBar.vue?vue&type=style&index=0&id=4528f228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528f228",
  null
  
)

export default component.exports